import type { Step } from 'react-joyride';
import { isDesktop } from '@zola-helpers/client';

import STEP_1 from './Step1';
import STEP_2 from './Step2';
import STEP_3 from './Step3';

const STEPS: Step[] = isDesktop() ? [STEP_1, STEP_2, STEP_3] : [STEP_1];

export default STEPS;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ManageAddressCollectionLinkTour/Steps/index.ts